import { DOCUMENT_TYPE } from '@tencent/ark-model';
import { setNewWindowUrl } from '@tencent/tencent_doc_open_url';
import { getQuery } from 'sutils';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import tdocsBridge from '@src/slide/infrastructure/module/independent/tdocsBridge/tdocsBridge';
import { onServicesReady } from '@src/slide/domain/slide-app/utils/service-awaiter';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { ISlideAppService } from '@src/slide/domain/slide-app/core/interfaces/slide-app-service.interface';
import { DVER } from './constants';
import { OnlineEditServices } from '../online/core/online-edit-services.core';
import userLocalStorage, { LocalStorageKeys } from '@src/slide/infrastructure/module/independent/local-storage';

function isOfflineDebug() {
    return !!getQuery('offlineDebug');
}

function isBlankPage() {
    return window.location.href.indexOf('/blankpage/') !== -1;
}

/**
 * 离线编辑能力是否可用
 * 当前只有移动App和桌面App会启动
 */
export function isOfflineEditEnable() {
    const isEnable = browser.isTencentDocApp || browser.isTencentDocDesktopApp || isOfflineDebug();
    return isEnable && !isBlankPage();
}

export function isSyncManagerEnabled() {
    return false;
    // return browser.isTencentDocDesktopApp;
}

/**
 * 显示空白页
 */
export function showBlankPage(secretId: string) {
    const blankPageData = {
        docId: secretId,
        sourcePadType: DOCUMENT_TYPE.slide,
    };
    userLocalStorage.setItem(LocalStorageKeys.BLANK_PAGE_DATA, blankPageData);

    // 跳转时， url参数不能丢， 比如jumpuin
    let url = window.location.href;
    if (url.indexOf('?') !== -1 && window.location.search) {
        let query = window.location.search;
        const queryArray = query.split('&');
        if (queryArray.indexOf('new=true') !== -1) {
            queryArray.splice(queryArray.indexOf('new=true'), 1);
            query = queryArray.join('&');
        }
        url = `${window.location.origin}${window.location.pathname}${query}`;
    }

    url = url.replace(/\/slide\//, '/blankpage/');
    if (browser.isTencentDocApp) {
        window.dispatchEvent(new Event('unload'));
    }
    setNewWindowUrl(window, url);
}

/**
 * 通知客户端做 url 和 dver 的关系映射
 */
export function mapDocumentVersion(secretId: string, dver: string = DVER) {
    const mapDocumentVersionParam = {
        url: `https://${location.hostname}/slide/${secretId}`,
        dver,
    };
    tdocsBridge.invokeDocx('mapDocumentVersion', mapDocumentVersionParam);
}

/**
 * SlideApp ready 同时确保数据全部加载完成
 * @returns
 */
export function waitForSlideAppReady(): Promise<ISlideAppService> {
    const { SlideAppService, ContentStatusManager } = SlideDataServices;
    return new Promise((resolve) => {
        onServicesReady([SlideAppService, ContentStatusManager], (app, contentStatus) => {
            contentStatus.onDocumentReady(() => resolve(app));
        });
    });
}

export async function waitForReadyToEdit() {
    const clientVarsService = await SlideDataServices.ClientVarsService.promise();
    await waitForSlideAppReady();
    if (clientVarsService.isLocalEdit()) return;
    const collaborationManager = await OnlineEditServices.CollaborationManager.promise();
    return new Promise<void>(resolve => collaborationManager.onCollaborationReady(resolve));
}

export function waitForContextDataReady() {
    const { SlideAppService, ContentStatusManager, DocInfoManager } = SlideDataServices;
    return new Promise<void>((resolve) => {
        onServicesReady([
            SlideAppService,
            ContentStatusManager,
            DocInfoManager,
        ], (app, contentStatus) => {
            contentStatus.onDocumentReady(() => resolve());
        });
    });
}
